import { Alert, Button, Classes, Dialog, Intent } from "@blueprintjs/core";
import { Form, Formik } from "formik";
import React, { useCallback, useContext, useState } from "react";
import ProjectVariables from "./schedules/form/ProjectVariables";
import { v4 as uuid } from "uuid";
import RunProgressDialog from "./RunProgressDialog";
import { RUN_PROJECT } from "graphql/mutations";
import { Company, UserInput } from "types";
import { SelectedProjectContext } from "utils/context";
import { setInitialUserInputs } from "utils/utils";
import { useMutation } from "@apollo/client";

type Props = {
    toggleRunForm: () => void;
    isOpen: boolean;
};

type ProjectRun = {
    company: Company;
    user_inputs: { [key: string]: UserInput } | undefined;
};

const AUTOREQUESTPREFIX = "autorequest_";

export default function RunProjectDialog({ toggleRunForm, isOpen }: Props) {
    const [project] = useContext(SelectedProjectContext);
    //const [runSNProject] = useMutation<{ runSNProject: { taskId: string } }>(RUN_SN_PROJECT);
    const [runProject] = useMutation<{ runProject: { requestId: string } }>(RUN_PROJECT);
    const [alertOpen, setAlertOpen] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const [taskId, setTaskId] = useState("");
    const toggleAlert = useCallback(() => {
        setAlertOpen(!alertOpen);
    }, [alertOpen]);

    const toggleProgress = useCallback(() => {
        setShowProgress(!showProgress);
    }, [showProgress]);

    const handleSubmit = useCallback(
        async (data: ProjectRun) => {
            // if (params.parentId) {
            //     await runSNProject({
            //         variables: {
            //             companySysId: data.company.id,
            //             projectId: project?.projectId,
            //             userInputs: data.user_inputs,
            //             parentId: params.parentId
            //         }
            //     })
            //         .then((res) => {
            //             console.log("run sn project: ", JSON.stringify(res));
            //             toggleProgress();
            //             if (res.data && res.data.runSNProject) {
            //                 setTaskId(res.data.runSNProject.taskId);
            //             }
            //         })
            //         .catch((err) => {
            //             console.error(err);
            //         })
            //         .finally(() => {
            //             //setParams({ ...params, parentId: "" }); // clear sn task //todo: create UI to associate task instead of depending on parameter
            //         });
            // } else {
            await runProject({
                variables: {
                    companySysId: data.company.id,
                    projectId: project?.projectId,
                    userInputs: data.user_inputs,
                    taskId: uuid()
                }
            })
                .then((res) => {
                    if (res.data && res.data.runProject) {
                        const requestId = res.data.runProject.requestId;
                        setTaskId(requestId.substring(AUTOREQUESTPREFIX.length));
                        toggleProgress();
                    }
                })
                .catch((err) => {
                    console.log("error: ", err);
                });

            toggleRunForm();
        },
        [toggleRunForm, project, toggleProgress, runProject]
    );

    return (
        <>
            <Formik
                onSubmit={async (values) => {
                    toggleAlert();
                    await handleSubmit(values);
                }}
                enableReinitialize
                initialValues={{
                    company: { name: "", id: "", ops: false },
                    user_inputs: project ? setInitialUserInputs(project.userInputs) : {}
                }}
            >
                {({ isSubmitting, values, submitForm, resetForm }) => {
                    return (
                        <Form>
                            <Alert
                                cancelButtonText="Cancel"
                                confirmButtonText="Confirm"
                                icon="play"
                                intent={Intent.SUCCESS}
                                isOpen={alertOpen}
                                onCancel={toggleAlert}
                                onConfirm={submitForm}
                            >
                                <p>Are you sure you want to run this project?</p>
                            </Alert>
                            <Dialog
                                className={Classes.OVERLAY_SCROLL_CONTAINER}
                                isOpen={isOpen}
                                onClose={() => {
                                    toggleRunForm();
                                    resetForm();
                                }}
                                title="Project Variables"
                            >
                                <div>
                                    <ProjectVariables userInputs={project?.userInputs} />
                                </div>
                                <div className={Classes.DIALOG_FOOTER}>
                                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                                        <Button
                                            disabled={isSubmitting}
                                            intent="primary"
                                            text="Run"
                                            onClick={toggleAlert}
                                        />
                                    </div>
                                </div>
                            </Dialog>
                            {/* <Collapse isOpen={true}>
                            <Pre>{JSON.stringify(values, null, 2)}</Pre>
                        </Collapse> */}
                        </Form>
                    );
                }}
            </Formik>
            {taskId && <RunProgressDialog isOpen={showProgress} toggle={toggleProgress} taskId={taskId} />}
        </>
    );
}
